import { HttpClientClass } from '~/services/http-client'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const apiBase = config.public.apiBase
  const httpClient = new HttpClientClass(apiBase)

  return {
    provide: {
      http: httpClient,
    },
  }
})
